import { useId } from 'react';

// The CAP sparkle — the brand's four-point star, used as the assistant's
// mark in the launcher pill, the panel header, the dashboard brief lockup and
// beside every assistant message. Built as a real SVG so it stays crisp at
// every size.

interface CapMarkProps {
	size?: number;
	// 'light' = light star for dark surfaces (the green pill / a dark header);
	// 'dark' = deep-green star for the cream and white surfaces.
	tone?: 'light' | 'dark';
	className?: string;
}

// The star: four sharp points joined by concave curves, drawn on a 0–100 box.
const STAR_PATH =
	'M50 1 C52.4 25.6 74.4 47.6 99 50 C74.4 52.4 52.4 74.4 50 99 C47.6 74.4 25.6 52.4 1 50 C25.6 47.6 47.6 25.6 50 1 Z';

const TONES = {
	light: { core: '#FFFFFF', edge: '#DFE9DC' },
	dark: { core: '#3C5A45', edge: '#25392B' },
} as const;

const CapMark = ({ size = 30, tone = 'dark', className }: CapMarkProps) => {
	const uid = useId();
	const starId = `${uid}-star`;
	const palette = TONES[tone];

	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox="0 0 100 100"
			style={{ flex: `0 0 ${size}px` }}
			aria-hidden="true"
		>
			<defs>
				{/* Slight top-left sheen so the star reads as lit rather than flat. */}
				<linearGradient id={starId} x1="24%" y1="8%" x2="78%" y2="94%">
					<stop offset="0%" stopColor={palette.core} />
					<stop offset="100%" stopColor={palette.edge} />
				</linearGradient>
			</defs>

			<path d={STAR_PATH} fill={`url(#${starId})`} />
		</svg>
	);
};

export default CapMark;
